import DailyEarningsGapsFilter from "./DailyEarningsGapsFilter";
import DailyEarningsGapsItem from "./DailyEarningsGapsItem";

const DailyEarningsGaps = () => {
  return (
    <>
      <DailyEarningsGapsFilter />
      <DailyEarningsGapsItem />
    </>
  );
};

export default DailyEarningsGaps;
